import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import S3FileUpload from "react-s3";
import { useHistory } from "react-router-dom";
import Loading from "../../components/Common/Loading";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const CreateSolution = (props) => {
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [stats, setStats] = useState([
    {
      title: "",
      description: "",
    },
  ]);
  const [cards, setCards] = useState([
    {
      image: "",
      title: "",
      description: "",
    },
  ]);
  const [sections, setSections] = useState([
    {
      title: "",
      heading: "",
      description: "",
      image: "",
      list: [""],
    },
  ]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  const history = useHistory();
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "solutions",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  //handleCardImage
  const handleCardImage = (event, index) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        const newCard = [...cards];
        newCard[index][
          "image"
        ] = `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`;
        setCards(newCard);
      })
      .catch((err) => console.log(err));
  };

  // remove card image
  const removeCardImage = (index) => {
    const newCard = [...cards];
    newCard[index]["image"] = "";
    setCards(newCard);
  };

  // handleSectionImage
  const handleSectionImage = (event, index) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        console.log(
          "image upload",
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
        const newSection = [...sections];
        newSection[index][
          "image"
        ] = `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`;
        setSections(newSection);
      })
      .catch((err) => console.log(err));
  };

  // removeSectionImage
  const removeSectionImage = (index) => {
    const newSection = [...sections];
    newSection[index]["image"] = "";
    setSections(newSection);
  };

  // handleSectionChange
  const handleSectionChange = (event, index) => {
    const newSection = [...sections];
    newSection[index][event.target.name] = event.target.value;
    setSections(newSection);
  };

  // addNewSection
  const addNewSection = () => {
    setSections([
      ...sections,
      {
        title: "",
        heading: "",
        description: "",
        image: "",
        list: [""],
      },
    ]);
  };

  // deleteSection
  const deleteSection = (index) => {
    const newSection = [...sections];
    newSection.splice(index, 1);
    setSections(newSection);
  };

  // handleCardsInput
  const handleCardsInput = (event, index) => {
    const newCard = [...cards];
    newCard[index][event.target.name] = event.target.value;
    setCards(newCard);
  };

  //addNewCard
  const addNewCard = () => {
    setCards([...cards, { image: "", title: "", description: "" }]);
  };

  // removeCard
  const removeCard = (index) => {
    const newCard = [...cards];
    newCard.splice(index, 1);
    setCards(newCard);
  };

  // handleListChange
  const handleListChange = (event, index, index2) => {
    const newSection = [...sections];
    newSection[index2]["list"][index] = event.target.value;
    setSections(newSection);
  };

  // removeListNewItem
  const removeListNewItem = (index, index2) => {
    const newSection = [...sections];
    newSection[index2]["list"].splice(index, 1);
    setSections(newSection);
  };

  // addNewListitem
  const addNewListitem = (index) => {
    const newSection = [...sections];
    newSection[index]["list"].push("");
    setSections(newSection);
  };

  // Todo: Stats
  // handleStatsChange
  const handleStatsChange = (event, index) => {
    const newStats = [...stats];
    newStats[index][event.target.name] = event.target.value;
    setStats(newStats);
  };

  //deleteStatsItem
  const deleteStatsItem = (index) => {
    const newStats = [...stats];
    newStats.splice(index, 1);
    setStats(newStats);
  };

  // addNewStatsItem
  const addNewStatsItem = () => {
    setStats([...stats, { title: "", description: "" }]);
  };

  //   console.log("sections>>>", sections);

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (image === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Upload Image",
      });
      return;
    } else {
      setIsLoading(true);
      apiReq(
        url.CREATE_SOLUTIONS,
        {
          title: data.title,
          description: data.description,
          icon: image,
          slug: data.title.toLowerCase().split(" ").join("-"),
          sections: sections,
          cards: cards,
          index: data.index,
          section_title: data.section_title,
          section_description: data.section_description,
          other_title: data.other_title,
          other_description: data.other_description,
          cta_title: data.cta_title,
          cta_link: data.cta_link,
          stats: stats,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            history.push("/solutions");
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // Todo: Drag and Drop
  const onDragEndHandle = (result) => {
    if (!result.destination) return;
    const items = Array.from(sections);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setSections(items);
  };

  // console.log("sections>>>", sections);

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Create new solution</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mt-4">
                  <h5>Intro Section</h5>
                  <hr />
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="mb-3">
                      <label>Icon</label>
                      <div
                        className="dropzone p-4 mb-3"
                        style={{ minHeight: 120, backgroundColor: "#eeeeee" }}
                      >
                        {!image ? (
                          <div className="needsclick">
                            <div className="mb-3">
                              <i className="ri-image-line display-4 text-muted"></i>
                            </div>
                            <h5 className="opacity-40">Icon Image</h5>
                            <input
                              type="file"
                              className="image_upload_input"
                              onChange={(e) => handleLogoUpload(e)}
                            />
                          </div>
                        ) : (
                          <div className="filled_image">
                            <img
                              src={image}
                              alt="image"
                              className="img-fluid"
                              style={{ width: "100%" }}
                            />
                            <div
                              className="remove_image"
                              onClick={() => setImage(null)}
                            >
                              <i className="mdi mdi-close-thick"></i>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="row">
                      <div className="col-md-10">
                        <div className="mb-3">
                          <label>
                            Title{" "}
                            <small
                              className="text-muted"
                              style={{ opacity: 0.5 }}
                            >
                              ({allFields?.title?.length} / 60)
                            </small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter title"
                            {...register("title", { required: true })}
                          />
                          {errors.title && (
                            <span className="text-danger">
                              Title is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-3">
                          <label>Index</label>
                          <input
                            type="number"
                            defaultValue={0}
                            className="form-control"
                            placeholder="Enter index"
                            {...register("index", { required: true })}
                          />
                          {errors.index && (
                            <span className="text-danger">
                              Index is required
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label>
                        Description{" "}
                        <small className="text-muted" style={{ opacity: 0.5 }}>
                          ({allFields?.description?.length} / 150)
                        </small>
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder="Enter description"
                        {...register("description", { required: true })}
                        style={{ resize: "none", minHeight: 80 }}
                      />
                      {errors.description && (
                        <span className="text-danger">
                          Description is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>CTA Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter title"
                        {...register("cta_title", { required: true })}
                      />
                      {errors.cta_title && (
                        <span className="text-danger">
                          CTA Title is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>CTA Link</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter title"
                        {...register("cta_link", { required: true })}
                      />
                      {errors.cta_link && (
                        <span className="text-danger">
                          CTA Link is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <hr />
                <div className="first_section_wrapper mt-4">
                  <div className="row">
                    <div className="col-md-6">
                      <h5 className="mt-3">First Section</h5>
                    </div>
                  </div>

                  <hr />
                  <div className="mb-3">
                    <label>
                      Section title{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.section_title?.length} / 25)
                      </small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter section title"
                      {...register("section_title", { required: true })}
                    />
                    {errors.title && (
                      <span className="text-danger">Title is required</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label>
                      Section Description{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.section_description?.length} / 60)
                      </small>
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Enter section description"
                      {...register("section_description", { required: true })}
                      style={{ resize: "none", minHeight: 80 }}
                    />
                    {errors.description && (
                      <span className="text-danger">
                        Description is required
                      </span>
                    )}
                  </div>
                  <h4>Section Cards</h4>
                  <div className="py-3">
                    <div className="section_cards">
                      {cards.map((item, index) => {
                        return (
                          <div>
                            <div className="row">
                              <div className="col-md-6">
                                <h4>Card: {item.title}</h4>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => removeCard(index)}
                                  >
                                    <i className="ri-delete-bin-line"></i>{" "}
                                    Delete this card
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="row mt-3" key={`card${index + 2}`}>
                              <div className="col-md-4">
                                <label>Section Card Image</label>
                                <div className="image_wrap">
                                  <div
                                    className="dropzone p-4 mb-3"
                                    style={{ minHeight: 120 }}
                                  >
                                    {!item.image ? (
                                      <div className="needsclick">
                                        <div className="mb-3">
                                          <i className="ri-image-line display-4 text-muted"></i>
                                        </div>
                                        <h5 className="opacity-40">
                                          Section Card Image
                                        </h5>
                                        <small className="text-muted mb-0 text-center">
                                          <strong>(376X225)</strong>
                                        </small>
                                        <input
                                          type="file"
                                          className="image_upload_input"
                                          onChange={(e) =>
                                            handleCardImage(e, index)
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <div className="filled_image">
                                        <img
                                          src={item.image}
                                          alt={item.title}
                                          className="img-fluid"
                                        />
                                        <div
                                          className="remove_image"
                                          onClick={() => removeCardImage(index)}
                                        >
                                          <i className="mdi mdi-close-thick"></i>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <label>
                                    Title{" "}
                                    <small
                                      className="text-muted"
                                      style={{ opacity: 0.5 }}
                                    >
                                      ( 60)
                                    </small>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Please enter title"
                                    value={item.title}
                                    name="title"
                                    onChange={(e) => handleCardsInput(e, index)}
                                  />
                                </div>
                                <div className="mb-3">
                                  <label>
                                    Description{" "}
                                    <small
                                      className="text-muted"
                                      style={{ opacity: 0.5 }}
                                    >
                                      ( 150)
                                    </small>
                                  </label>
                                  <textarea
                                    type="text"
                                    className="form-control"
                                    placeholder="Please enter title"
                                    value={item.description}
                                    name="description"
                                    onChange={(e) => handleCardsInput(e, index)}
                                    style={{ resize: "none", minHeight: 100 }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="pb-4">
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={addNewCard}
                      >
                        Add new card
                      </button>
                    </div>
                  </div>
                </div>
                <h5 className="mt-4">Sections</h5>
                <hr />
                <DragDropContext
                  onDragEnd={(result) => onDragEndHandle(result)}
                >
                  <Droppable droppableId="sectionItems_wrapper">
                    {(provided) => (
                      <div
                        className="sectionItems_wrapper"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {sections.map((item, index) => (
                          <Draggable
                            key={index}
                            draggableId={"dd" + index}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                className="section_wrap"
                                {...provided.draggableProps}
                                ref={provided.innerRef}
                              >
                                <div className="section_header">
                                  <div className="mb-3 row">
                                    <div className="col-md-8">
                                      <h5 className="section_title">
                                        <span
                                          className="move_secction"
                                          {...provided.dragHandleProps}
                                        >
                                          <i className="ri-drag-move-2-line"></i>
                                        </span>
                                        Section {index + 1}: {item.title}
                                      </h5>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="d-flex justify-content-end">
                                        <button
                                          className="btn btn-danger"
                                          type="button"
                                          onClick={() => deleteSection(index)}
                                        >
                                          <i className="ri-delete-bin-line"></i>{" "}
                                          Delete this section
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row" key={index}>
                                  <div className="col-md-4">
                                    <label>Section Image</label>
                                    <div className="image_wrap">
                                      <div
                                        className="dropzone p-4 mb-3"
                                        style={{ minHeight: 120 }}
                                      >
                                        {!item.image ? (
                                          <div
                                            className="needsclick"
                                            // {...getRootProps()}
                                          >
                                            {/* <input /> */}
                                            <div className="mb-3">
                                              <i className="ri-image-line display-4 text-muted"></i>
                                            </div>
                                            <h5 className="opacity-40">
                                              Section Image
                                            </h5>
                                            <small className="text-muted mb-0 text-center">
                                              <strong>(550X550)</strong>
                                            </small>
                                            <input
                                              type="file"
                                              className="image_upload_input"
                                              onChange={(e) =>
                                                handleSectionImage(e, index)
                                              }
                                            />
                                          </div>
                                        ) : (
                                          <div className="filled_image">
                                            <img
                                              src={item.image}
                                              alt={item.title}
                                              className="img-fluid"
                                            />
                                            <div
                                              className="remove_image"
                                              onClick={() =>
                                                removeSectionImage(index)
                                              }
                                            >
                                              <i className="mdi mdi-close-thick"></i>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-8">
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label>
                                            Title{" "}
                                            <small
                                              className="text-muted"
                                              style={{ opacity: 0.5 }}
                                            >
                                              (50)
                                            </small>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter title"
                                            name="title"
                                            value={item.title}
                                            onChange={(e) =>
                                              handleSectionChange(e, index)
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label>
                                            Heading{" "}
                                            <small
                                              className="text-muted"
                                              style={{ opacity: 0.5 }}
                                            >
                                              (60)
                                            </small>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter heading"
                                            name="heading"
                                            value={item.heading}
                                            onChange={(e) =>
                                              handleSectionChange(e, index)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="mb-3">
                                      <label>
                                        Description{" "}
                                        <small
                                          className="text-muted"
                                          style={{ opacity: 0.5 }}
                                        >
                                          (180)
                                        </small>
                                      </label>
                                      <textarea
                                        className="form-control"
                                        placeholder="Enter description"
                                        name="description"
                                        value={item.description}
                                        onChange={(e) =>
                                          handleSectionChange(e, index)
                                        }
                                        style={{
                                          resize: "none",
                                          minHeight: 100,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <h5>Checkboxes</h5>
                                <hr />
                                {item.list.map((listItem, ind) => (
                                  <div
                                    className="row mb-3"
                                    key={`list${ind + 20}`}
                                  >
                                    <div className="col-md-10">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="..."
                                        name="list"
                                        value={listItem}
                                        onChange={(e) =>
                                          handleListChange(e, ind, index)
                                        }
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <button
                                        type="button"
                                        className="btn w-100 btn-danger"
                                        onClick={() =>
                                          removeListNewItem(ind, index)
                                        }
                                      >
                                        <i className="ri-delete-bin-line"></i>{" "}
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                ))}
                                <div className="d-flex">
                                  <div className="justify-content-end">
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      onClick={() => addNewListitem(index)}
                                    >
                                      Add new item
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                <hr />
                <div className="d-flex justify-content-end mt-2">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={() => addNewSection()}
                  >
                    Add New Section
                  </button>
                </div>

                <h5 className="mt-4">Other stats</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.other_title?.length} / 50)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter title"
                    {...register("other_title", { required: false })}
                  />
                  {errors.other_title && (
                    <span className="text-danger">Title is required</span>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.other_description?.length} / 150)
                    </small>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Enter description"
                    {...register("other_description", { required: false })}
                  />
                  {errors.other_description && (
                    <span className="text-danger">Description is required</span>
                  )}
                </div>
                <hr />
                <div className="stats_wrapper">
                  {stats.map((item, index) => (
                    <div className="row mb-3" key={`stats${index + 3}`}>
                      <div className="col-md-10">
                        <div className="row">
                          <div className="col-md-6">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter title"
                              name="title"
                              value={item.title}
                              onChange={(e) => handleStatsChange(e, index)}
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter description"
                              name="description"
                              value={item.description}
                              onChange={(e) => handleStatsChange(e, index)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-danger w-100"
                          type="button"
                          onClick={() => deleteStatsItem(index)}
                        >
                          <i className="ri-delete-bin-line"></i> Delete
                        </button>
                      </div>
                    </div>
                  ))}
                  <hr />
                  <div className="d-flex justify-content-end mt-2">
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={addNewStatsItem}
                    >
                      Add New Stats
                    </button>
                  </div>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />

                <div>
                  <button type="submit" className="btn btn-primary">
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreateSolution;
